// MS buffer before calling all window resize functions
var iWindowResizeTimeout = 75;

var lang = 'en';
if (document.getElementsByTagName("body")[0].className.match(/lang-fr/)) {
  lang = 'fr';
}
else if (document.getElementsByTagName("body")[0].className.match(/lang-es/)) {
  lang = 'es';
}

if(lang === 'fr') {
  var termPrev = "Précédent";
  var termNext = "Suivant";
  var termOpenClose = "Ouvrir/Fermer";
} else if(lang == 'en') {
  var termPrev = "Previous";
  var termNext = "Next";
  var termOpenClose = "Open/Close";
} else if(lang == 'es') {
  var termPrev = "Previo";
  var termNext = "Próximo";
  var termOpenClose = "Abrir/Cerrar";
}


// https://stackoverflow.com/questions/2854407/javascript-jquery-window-resize-how-to-fire-after-the-resize-is-completed
var waitForFinalEvent = (function () {
  var timers = {};
  return function (callback, ms, uniqueId) {
    if (!uniqueId) {
      uniqueId = "Don't call this twice without a uniqueId";
    }
    if (timers[uniqueId]) {
      clearTimeout (timers[uniqueId]);
    }
    timers[uniqueId] = setTimeout(callback, ms);
  };
})();

function pgs_is_number(sValue) {
  return parseInt(sValue) > 0 || parseInt(sValue) < 1 ;
}
